export default "__VITE_ASSET__Dw6e62LZ__"